// src/features/stabilimenti/stabilimentiThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  // Stabilimenti actions
  setStabilimenti,
  addStabilimenti,
  updateStabilimenti,
  removeStabilimenti,
  setSingleStabilimento,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,

  // Enum actions
  setTipologia,
  enumRequestStart,
  enumRequestSuccess,
  enumRequestFailure,
  setSelectedStabilimentiId,
} from "./stabilimentiSlice";
import stabilimentiAPI from "../../services/stabilimentiAPI";
import { toast } from "react-toastify";

// Fetch all stabilimenti
export const fetchStabilimenti = createAsyncThunk(
  "stabilimenti/fetchStabilimenti",
  async (params, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await stabilimentiAPI.getAllStabilimenti(params);
      console.log("Fetched Stabilimenti Data:", response.data);
      dispatch(setStabilimenti(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch stabilimenti.";
        console.error("Error fetching stabilimenti:", errorMessage);
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fetch single stabilimento
export const fetchSingleStabilimento = createAsyncThunk(
  "stabilimenti/fetchSingleStabilimento",
  async (stabilimentoId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await stabilimentiAPI.getStabilimenti(stabilimentoId);
      dispatch(setSelectedStabilimentiId(stabilimentoId));
      dispatch(setSingleStabilimento(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch stabilimento.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Create stabilimento
export const createStabilimento = createAsyncThunk(
  "stabilimenti/createStabilimento",
  async (stabilimentoData, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await stabilimentiAPI.createStabilimenti(stabilimentoData);
      dispatch(addStabilimenti(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create stabilimento.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Update stabilimento
export const updateSingleStabilimento = createAsyncThunk(
  "stabilimenti/updateSingleStabilimento",
  async ({ StablimintiId, StablimintData }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await stabilimentiAPI.updateStabilimenti(StablimintiId, StablimintData);
      dispatch(updateStabilimenti(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update stabilimento.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Delete stabilimento
export const deleteStabilimento = createAsyncThunk(
  "stabilimenti/deleteStabilimento",
  async (stabilimentoId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
    const response =  await stabilimentiAPI.deleteStabilimenti(stabilimentoId);
      dispatch(removeStabilimenti(stabilimentoId));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete stabilimento.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Duplicate stabilimento
export const duplicateStabilimento = createAsyncThunk(
  "stabilimenti/duplicateStabilimento",
  async (stabilimentoId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await stabilimentiAPI.duplicateStabilimenti(stabilimentoId);
      dispatch(addStabilimenti(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to duplicate stabilimento.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Fetch Tipologia Enum
export const fetchTipologia = createAsyncThunk(
  "stabilimenti/fetchTipologia",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart('tipologia'));
    try {
      const response = await stabilimentiAPI.getTipologia();
      dispatch(setTipologia(response.data.data));
      dispatch(enumRequestSuccess('tipologia'));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch tipologia.";
      dispatch(enumRequestFailure({
        enumType: 'tipologia',
        error: errorMessage
      }));
      throw new Error(errorMessage);
    }
  }
);